export default __webpack_public_path__ + "static/media/search.aaa92efc.svg";